// src/app/argent/FenetresArgent.jsx — les fenêtres de confirmation de l'argent
// (facture, envoi, brouillon, suppressions, avoir), les fenêtres de saisie et
// l'analyse.
// CHEMIN ARGENT. Déplacé octet pour octet depuis src/App.jsx (P-3.5, squelette,
// partie 2) : seuls changent l'emballage (signature, retour) et les imports.

import { DS } from '../../lib/ui'
import { fmtE, fmt2 } from '../../lib/format'
import { TEXTE_FACTURE_LECTURE_RATEE } from '../../lib/argent-lecture'
import { isDraftInvoice } from '../../lib/invoices'
import { describeAvoir } from '../../lib/invoice-avoir-flow'
import { describeAvoirEnvoi } from '../../lib/avoir-send-flow'
import { validerCourriel, VARIABLES_COURRIEL_FACTURE, remplirModele } from '../../lib/courriel-facture'
import { decrireSuppressionFacture } from '../../lib/facture-suppression'
import { computePreviewNumber } from '../../lib/invoice-preview'
import { Modal } from '../../components/Modal'
import ResaModal from '../../modals/ResaModal'
import ProrataSplitModal from '../../modals/ProrataSplitModal'
import ExtraModal from '../../modals/ExtraModal'

export function fenetresArgent({
  cfg, argentLectureRatee, data, invoicesArchiveList,
  confirmAvoirChecked, setConfirmAvoirChecked,
  confirmEnvoiAvoirChecked, setConfirmEnvoiAvoirChecked, month, confirm, setConfirm, resaModal,
  setResaModal, prorataModal, setProrataModal, extraModal, setExtraModal, ajustModal, setAjustModal,
  currentUser, monthLabel, saveData, sendingEmail, genBusy, invoiceSequences, iaAnalyse,
  setIaAnalyse, saveResa, saveResaV2, deleteResaV2, createResaV2, deleteManualResa, deleteResa,
  saveExtra, deleteExtra, saveAjust, deleteAjust, sendFactureEmail, envoyerFactureExistanteUI,
  variablesCourrielFacture, ouvrirEnvoiFacture, doGenFacture, emettreBrouillon,
  handlePreviewFacture, deleteFactureCoherent, emitAvoir, resolveAvoirProprio,
  resolveAvoirEmailDest, findAvoirRemplacante, sendAvoir,
}) {
  return (
    <>
      {confirm?.type==="facture" && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:DS.white,borderRadius:16,padding:24,maxWidth:340,width:"100%",boxShadow:"0 16px 48px rgba(0,0,0,.22)",fontFamily:DS.fontBody}}>
            <div style={{fontFamily:DS.fontDisplay,fontWeight:700,fontSize:17,color:DS.navy,marginBottom:6}}>Générer la facture</div>
            <div style={{fontSize:13,color:DS.textLight,marginBottom:4}}>N° attribué à l'émission (séquentiel inviolable CGI 289) · {confirm.log.nom}</div>
            <div style={{fontSize:13,color:"#555",marginBottom:20}}>{monthLabel}</div>

            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {/* Envoyer au propriétaire — désactivé si pas d'email proprio, et
                  pendant une lecture ratée (F13). N'ENVOIE RIEN : ouvre la
                  fenêtre de relecture du courriel (aucun numéro tiré à
                  l'ouverture). */}
              <button onClick={()=>ouvrirEnvoiFacture(confirm.prop,confirm.log)}
                disabled={argentLectureRatee||!confirm.prop.email||!!sendingEmail||genBusy}
                title={!confirm.prop.email ? "Email proprio manquant — ajoutez-le dans la fiche logement (Logements > Info FBZ > Propriétaire)" : ""}
                style={{padding:12,background:(confirm.prop.email&&!genBusy&&!argentLectureRatee)?DS.navy:"#e2e8f0",color:(confirm.prop.email&&!genBusy&&!argentLectureRatee)?"#fff":"#aaa",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:(confirm.prop.email&&!sendingEmail&&!genBusy&&!argentLectureRatee)?"pointer":"not-allowed",fontFamily:DS.fontBody,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                {argentLectureRatee?TEXTE_FACTURE_LECTURE_RATEE:sendingEmail?"⏳ Envoi en cours...":"📧 Envoyer au propriétaire…"}
              </button>
              {/* Générer la facture — ouvre aperçu HTML + consomme le numéro + ajoute à l'historique (emailEnvoye:false) */}
              <button onClick={()=>doGenFacture(confirm.prop,confirm.log)}
                disabled={argentLectureRatee||genBusy||!!sendingEmail}
                style={{padding:12,background:(argentLectureRatee||genBusy||sendingEmail)?"#e2e8f0":"#eef4fb",color:(argentLectureRatee||genBusy||sendingEmail)?"#aaa":DS.navy,border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:(argentLectureRatee||genBusy||sendingEmail)?"not-allowed":"pointer",fontFamily:DS.fontBody}}>
                {argentLectureRatee?TEXTE_FACTURE_LECTURE_RATEE:genBusy?"⏳ Génération...":"🧾 Générer la facture"}
              </button>
              {/* Aperçu — lecture seule AVANT émission : ne consomme aucun numéro,
                  ne crée aucune facture, n'envoie rien (synchrone, anti popup-blocker). */}
              <button onClick={()=>handlePreviewFacture(confirm.prop,confirm.log)}
                disabled={argentLectureRatee||genBusy||!!sendingEmail}
                style={{padding:10,background:(argentLectureRatee||genBusy||sendingEmail)?"#e2e8f0":"#f4f7fb",color:(argentLectureRatee||genBusy||sendingEmail)?"#aaa":"#555",border:"1px solid #e2e8f0",borderRadius:10,fontWeight:600,fontSize:12,cursor:(argentLectureRatee||genBusy||sendingEmail)?"not-allowed":"pointer",fontFamily:DS.fontBody}}>
                {argentLectureRatee?TEXTE_FACTURE_LECTURE_RATEE:"👁️ Aperçu (sans émettre)"}
              </button>
              <button onClick={()=>setConfirm(null)}
                style={{padding:10,background:"#f4f7fb",color:"#555",border:"none",borderRadius:10,fontWeight:600,fontSize:12,cursor:"pointer",fontFamily:DS.fontBody}}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
      {/* RELECTURE DU COURRIEL AVANT ENVOI (2026-09-30). Objet et texte
          modifiables, variables en liste fermée. Rien ne part avant le clic
          sur « Envoyer » ; le numéro n'est tiré qu'à ce clic (sendFactureEmail
          → emettreEtEnvoyerFacture, qui valide AVANT de tirer).
          2026-10-03 : courriel simple et poli, la facture part en PDF JOINT
          (décision Dimitri), envoyée par le serveur. */}
      {confirm?.type==="envoiFacture" && (() => {
        const { prop, log } = confirm
        // `existante` = facture DÉJÀ émise (bouton « Envoyer » de l'Historique) :
        // son numéro est connu, aucun n'est tiré.
        const existante = confirm.existante || null
        const valeurs = existante
          ? { ...variablesCourrielFacture(prop, log), mois: existante.mois || monthLabel, numero: existante.num, montant: fmtE(existante.montant) }
          : { ...variablesCourrielFacture(prop, log), montant: fmtE(confirm.montantApercu) }
        const verdict = validerCourriel({ objet: confirm.objet, texte: confirm.texte })
        const occupe = !!sendingEmail
        const champ = {width:"100%",boxSizing:"border-box",border:`1px solid ${DS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,fontFamily:DS.fontBody,color:DS.navy}
        return (
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
            <div data-testid="fenetre-envoi-facture" style={{background:DS.white,borderRadius:16,padding:22,maxWidth:560,width:"100%",maxHeight:"92vh",overflowY:"auto",boxShadow:"0 16px 48px rgba(0,0,0,.22)",fontFamily:DS.fontBody}}>
              <div style={{fontFamily:DS.fontDisplay,fontWeight:700,fontSize:17,color:DS.navy,marginBottom:4}}>Courriel au propriétaire</div>
              <div style={{fontSize:12,color:DS.textLight,marginBottom:6}}>À : <b>{prop.email}</b> · {log.nom} · {existante ? `${existante.mois} · facture N° ${existante.num}` : monthLabel} · {fmtE(confirm.montantApercu)}</div>
              <div data-testid="courriel-piece-jointe" style={{fontSize:12,color:DS.navy,marginBottom:14}}>📎 Pièce jointe : <b>{existante ? `Facture-${existante.num}.pdf` : "la facture en PDF (numéro attribué à l'envoi)"}</b></div>
              <label style={{fontSize:11,fontWeight:700,color:"#5a6470",display:"block",marginBottom:4}}>Objet</label>
              <input data-testid="courriel-objet" value={confirm.objet} disabled={occupe} onChange={e=>setConfirm({...confirm, objet:e.target.value})} style={{...champ,marginBottom:4}}/>
              <div style={{marginBottom:10}}/>
              <label style={{fontSize:11,fontWeight:700,color:"#5a6470",display:"block",marginBottom:4}}>Texte du courriel</label>
              <textarea data-testid="courriel-texte" value={confirm.texte} disabled={occupe} onChange={e=>setConfirm({...confirm, texte:e.target.value})} rows={8} style={{...champ,resize:"vertical",marginBottom:8}}/>
              <div style={{fontSize:11,color:"#5a6470",marginBottom:12,lineHeight:1.6}}>
                Variables : {VARIABLES_COURRIEL_FACTURE.map(v => <span key={v.cle} title={v.libelle} style={{display:"inline-block",background:"#eef4fb",color:DS.navy,borderRadius:6,padding:"1px 6px",margin:"0 4px 4px 0",fontFamily:"monospace"}}>{`{${v.cle}}`}</span>)}
              </div>
              <div style={{fontSize:11,fontWeight:700,color:"#5a6470",marginBottom:4}}>Aperçu</div>
              <div data-testid="courriel-apercu" style={{background:"#fafbfc",border:"0.5px solid #eceef1",borderRadius:10,padding:"10px 12px",fontSize:12.5,color:"#2e3d4d",marginBottom:12}}>
                <div style={{fontWeight:700,marginBottom:6}}>{remplirModele(confirm.objet, valeurs)}</div>
                <div style={{whiteSpace:"pre-wrap",lineHeight:1.55}}>{remplirModele(confirm.texte, valeurs)}</div>
              </div>
              {!verdict.ok && <div data-testid="courriel-refus" style={{fontSize:12,color:DS.danger,marginBottom:10}}>{verdict.raison}</div>}
              <div style={{fontSize:11.5,color:DS.navy,background:"#fff8e6",border:`1px solid ${DS.amber}`,borderRadius:8,padding:"8px 10px",marginBottom:14,lineHeight:1.5}}>
                {confirm.essaiSeulement
                  ? <>Essai seulement : ce courriel part à <b>toi seul</b> (adresse de ton compte), objet préfixé « [ESSAI] », avec le PDF de la facture. Le propriétaire ne reçoit rien ; rien n'est noté ; la facture est inchangée.</>
                  : <>Ce courriel part <b>réellement</b> à {prop.email}, avec la facture en PDF jointe (en mode simulation, rien ne part et l'écran le dira). Il est envoyé depuis <b>contact@fullbnbzen.com</b> : les réponses du propriétaire y arrivent. {existante ? "Le PDF est le document déjà émis, tel quel : aucun numéro n'est tiré." : "Le numéro de facture est attribué au moment où tu cliques sur « Envoyer »."}</>}
              </div>
              {/* Captures #1559 : à 375 px, Retour et Envoyer passaient sous le pli —
                  la barre reste collée en bas de la fenêtre qui défile (bottom = -padding
                  de la fenêtre, 22 px : sinon le texte défile visible sous la barre). */}
              <div data-testid="courriel-boutons" style={{display:"flex",gap:8,position:"sticky",bottom:-22,background:DS.white,padding:"10px 0",zIndex:1}}>
                <button onClick={()=>setConfirm(existante ? null : {type:"facture", prop, log})} disabled={occupe}
                  style={{flex:1,minHeight:44,padding:11,background:"#f2f5f9",color:"#555",border:"none",borderRadius:8,fontWeight:600,cursor:occupe?"not-allowed":"pointer",fontFamily:DS.fontBody}}>Retour</button>
                {!confirm.essaiSeulement && <button data-testid="courriel-envoyer" onClick={(!verdict.ok||occupe) ? undefined : ()=>(existante ? envoyerFactureExistanteUI(existante, prop, log, { objet: confirm.objet, texte: confirm.texte }) : sendFactureEmail(prop, log, { objet: confirm.objet, texte: confirm.texte }, confirm.montantApercu))}
                  disabled={!verdict.ok||occupe}
                  style={{flex:1,minHeight:44,padding:11,background:(!verdict.ok||occupe)?"#cfd6de":DS.navy,color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:(!verdict.ok||occupe)?"not-allowed":"pointer",fontFamily:DS.fontBody}}>
                  {occupe ? "⏳ Envoi en cours…" : "Envoyer"}
                </button>}
              </div>
              {/* ESSAI À DIMITRI SEUL (2026-10-03) : facture déjà émise seulement
                  (aucun numéro tiré) ; le serveur force le destinataire à
                  l'adresse du compte connecté et n'écrit rien. */}
              {existante && (
                <button data-testid="courriel-essai" onClick={(!verdict.ok||occupe) ? undefined : ()=>envoyerFactureExistanteUI(existante, prop, log, { objet: confirm.objet, texte: confirm.texte }, { essai: true })}
                  disabled={!verdict.ok||occupe}
                  title="Le propriétaire ne reçoit rien ; rien n'est noté ; la facture est inchangée"
                  style={{marginTop:8,width:"100%",minHeight:40,padding:9,background:"none",color:DS.navy,border:`1px solid ${DS.navy}`,borderRadius:8,fontWeight:600,fontSize:12.5,cursor:(!verdict.ok||occupe)?"not-allowed":"pointer",fontFamily:DS.fontBody}}>
                  🧪 M'envoyer un essai, à moi seul{currentUser?.email ? ` (${currentUser.email})` : ''}
                </button>
              )}
            </div>
          </div>
        )
      })()}
      {/* ÉMETTRE UN BROUILLON (2026-09-30) : numéro définitif, AUCUN courriel. */}
      {confirm?.type==="emettreBrouillon" && (() => {
        const f = confirm.facture
        const prevu = computePreviewNumber({ prefix: f.prefix || 'P', year: new Date().getFullYear(), sequences: invoiceSequences })
        return <Modal
          title="Émettre cette facture ?"
          msg={`${f.log || 'Ce brouillon'} · ${f.mois} · ${fmtE(f.montant)}. Elle reçoit son numéro définitif${prevu ? ` (prévu : ${prevu})` : ''} — irréversible. Aucun courriel ne part : elle apparaîtra « Émise, non envoyée ».`}
          onOk={()=>emettreBrouillon(f)}
          onCancel={()=>setConfirm(null)}
          okLabel="Émettre"
          okColor={DS.navy}
        />
      })()}
      {confirm?.type==="resa" && <Modal title="Supprimer la réservation ?" msg="Cette action est irréversible." onOk={()=>deleteResa(confirm.lid,confirm.resaId)} onCancel={()=>setConfirm(null)}/>}
      {confirm?.type==="manual" && <Modal title="Supprimer la réservation manuelle ?" msg="Cette réservation saisie manuellement sera définitivement supprimée. Cette action est irréversible." onOk={()=>deleteManualResa(confirm.lid,confirm.resaId)} onCancel={()=>setConfirm(null)}/>}
      {confirm?.type==="resaV2" && <Modal
        title="Retirer cette réservation de la facturation ?"
        msg={`La réservation de ${fmt2(confirm.montant||0)} € reste dans Beds24 mais n'apparaîtra plus sur la facturation (ni au prochain rafraîchissement). Tu pourras la restaurer.`}
        onOk={()=>deleteResaV2(confirm.lid,confirm.resa)}
        onCancel={()=>setConfirm(null)}
        okLabel="Retirer de la facturation"
      />}
      {/* SUPPRESSION : un BROUILLON seulement (texte : decrireSuppressionFacture,
          src/lib/facture-suppression.js, testé). Une pièce émise ne
          s'efface jamais (CGI 289) : la corbeille n'y apparaît pas
          (HistoriquePanel) ; si la fenêtre s'ouvre quand même (onglet
          périmé), elle le dit et le bouton reste gris. Le serveur refuse de
          toute façon (peutSupprimerFacture). */}
      {confirm?.type==="deleteFacture" && (() => {
        const f = confirm.facture
        const d = decrireSuppressionFacture({ facture: f, estBrouillon: isDraftInvoice(f) })
        return <Modal
          title={d.titre}
          msg={d.msg}
          okDisabled={!d.possible}
          onOk={()=>{ if (d.possible) deleteFactureCoherent(f) }}
          onCancel={()=>setConfirm(null)}
          okLabel={d.okLabel}
          okColor={DS.marine}
        />
      })()}
      {confirm?.type==="extra" && <Modal title="Supprimer la prestation ?" msg="Cette action est irréversible." onOk={()=>deleteExtra(confirm.lid,confirm.extraId)} onCancel={()=>setConfirm(null)}/>}
      {confirm?.type==="ajust" && <Modal title="Supprimer l'ajustement ?" msg="Cette action est irréversible." onOk={()=>deleteAjust(confirm.log,confirm.ajId)} onCancel={()=>setConfirm(null)}/>}
      {/* AVOIR — les TROIS FAITS avant le clic : quelle pièce est annulée, quel
          numéro portera l'avoir, et que l'originale RESTE. Un avoir n'efface
          rien ; s'il le laissait croire, on aurait remplacé un mensonge par un
          autre. Texte = describeAvoir (src/lib/invoice-avoir-flow.js), testé. */}
      {confirm?.type==="avoirFacture" && (() => {
        const f = confirm.facture
        const d = describeAvoir({ facture: f, sequences: invoiceSequences || [] })
        return <Modal
          title="Annuler cette facture par un avoir ?"
          msg={d.possible ? "Un avoir est une pièce comptable NEUVE, irréversible (CGI 289). Voici exactement ce qui va se passer :" : d.raison}
          okDisabled={!d.possible || !confirmAvoirChecked}
          onOk={()=>{ if (confirmAvoirChecked) emitAvoir(f) }}
          onCancel={()=>{ setConfirm(null); setConfirmAvoirChecked(false) }}
          okLabel="Émettre l'avoir"
          okColor={DS.navy}
        >
          {d.possible && (
            <ol data-testid="avoir-faits" style={{margin:0,paddingLeft:18,fontSize:12,color:DS.navy,lineHeight:1.55,display:"flex",flexDirection:"column",gap:6}}>
              {d.faits.map((t, i) => <li key={i}>{t}</li>)}
            </ol>
          )}
          {/* La case : réelle, jamais pré-cochée. C'est elle qui rend le bouton
              cliquable — pas l'ouverture de la modale. */}
          {d.possible && (
            <label data-testid="confirm-avoir" style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:12,color:DS.navy,lineHeight:1.5,cursor:"pointer",background:"#fff8e6",border:`1px solid ${DS.amber}`,borderRadius:8,padding:"8px 10px",marginTop:10}}>
              <input type="checkbox" checked={confirmAvoirChecked} onChange={e=>setConfirmAvoirChecked(e.target.checked)} style={{marginTop:2}}/>
              <span>Je confirme : j'émets un <b>avoir</b> ({d.creditPrefix}) qui annule la facture N° {d.originalNumber}. La facture d'origine reste archivée, inchangée. Ce geste est irréversible.</span>
            </label>
          )}
        </Modal>
      })()}
      {/* ENVOI DE L'AVOIR — ce que l'écran dit AVANT le clic : quelle pièce
          part, à qui, et que l'ORIGINALE RESTE chez le propriétaire (on
          n'envoie pas un effacement, on envoie une explication). Texte =
          describeAvoirEnvoi (src/lib/avoir-send-flow.js), testé. */}
      {confirm?.type==="envoiAvoir" && (() => {
        const f = confirm.facture
        const d = describeAvoirEnvoi({
          avoir: f,
          originale: (invoicesArchiveList || []).find(x => x.invoiceId === f?.relatedInvoiceId) || null,
          emailDest: resolveAvoirEmailDest(f),
          remplacante: findAvoirRemplacante(f),
          propActuel: resolveAvoirProprio(f)?.nom || null,
        })
        return <Modal
          title="Envoyer cet avoir au propriétaire ?"
          msg={d.possible ? "Ce mail part RÉELLEMENT (EmailJS). Voici exactement ce qui va se passer :" : d.raison}
          okDisabled={!d.possible || !confirmEnvoiAvoirChecked}
          onOk={()=>{ if (confirmEnvoiAvoirChecked) sendAvoir(f) }}
          onCancel={()=>{ setConfirm(null); setConfirmEnvoiAvoirChecked(false) }}
          okLabel={d.dejaTransmis ? "Renvoyer l'avoir" : "Envoyer l'avoir"}
          okColor={DS.navy}
        >
          {d.possible && (
            <ol data-testid="envoi-avoir-faits" style={{margin:0,paddingLeft:18,fontSize:12,color:DS.navy,lineHeight:1.55,display:"flex",flexDirection:"column",gap:6}}>
              {d.faits.map((t, i) => <li key={i}>{t}</li>)}
            </ol>
          )}
          {/* La case : réelle, jamais pré-cochée — même mécanique que
              l'émission. Ce mail part vraiment (EmailJS tourne dans le
              navigateur : aucune variable d'env ne le retient) et il annonce
              à un propriétaire qu'une facture qu'il a reçue était fausse. */}
          {d.possible && (
            <label data-testid="confirm-envoi-avoir" style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:12,color:DS.navy,lineHeight:1.5,cursor:"pointer",background:"#fff8e6",border:`1px solid ${DS.amber}`,borderRadius:8,padding:"8px 10px",marginTop:10}}>
              <input type="checkbox" checked={confirmEnvoiAvoirChecked} onChange={e=>setConfirmEnvoiAvoirChecked(e.target.checked)} style={{marginTop:2}}/>
              <span>Je confirme : ce mail part <b>réellement</b> à {d.emailDest} et lui annonce que la facture N° {d.originalNumber} était fausse.</span>
            </label>
          )}
        </Modal>
      })()}
      {confirm?.type==="resetMois" && <Modal title="Effacer tout le mois ?" msg={`Supprimer toutes les données de ${monthLabel} ?`} onOk={()=>{const nd=JSON.parse(JSON.stringify(data));delete nd[month];saveData(nd);setConfirm(null)}} onCancel={()=>setConfirm(null)}/>}
      {confirm?.type==="resetProp" && <Modal title={`Effacer les données de ${confirm.propNom} ?`} msg={`Toutes les réservations de ${confirm.propNom} pour ${monthLabel} seront supprimées.`} onOk={()=>{
        const nd=JSON.parse(JSON.stringify(data))
        const prop=cfg.props.find(p=>p.id===confirm.propId)
        if(prop&&nd[month]){(prop.logs||[]).forEach(l=>{delete nd[month][l.id]})}
        saveData(nd);setConfirm(null)
      }} onCancel={()=>setConfirm(null)}/>}
      {/* MINEUR-1 — exclusivité mécanique : ResaModal masqué tant qu'une modale
          prorata est ouverte (render-guard XOR ; l'overlay sinon se superpose). */}
      {resaModal && !prorataModal && (()=>{
        // Lot 4 V2-create-manual : manualMode = création manuelle (manualcreate)
        // OU édition d'une résa déjà manuelle (resa.source==='manual').
        const manualMode = !!resaModal.manualcreate || resaModal.resa?.source==='manual'
        // Routage onSave : création manuelle → createResaV2 ; édition d'une
        // manuelle → saveResa (id-based, sûr, préserve source/plateforme) ;
        // sinon mode V2 (overrides) → saveResaV2 ; sinon V1 → saveResa.
        const onSave = r =>
          resaModal.manualcreate
            ? createResaV2(resaModal.lid, r)
            : resaModal.resa?.source==='manual'
              ? saveResa(resaModal.lid, r)
              : resaModal.v2
                ? saveResaV2(resaModal.lid, resaModal.resa, r)
                : saveResa(resaModal.lid, r)
        return <ResaModal lid={resaModal.lid} logNom={resaModal.logNom} resa={resaModal.resa} v2={!!resaModal.v2} manualMode={manualMode} taux={resaModal.taux} hasStableCode={resaModal.hasStableCode!==false} onSave={onSave} onClose={()=>setResaModal(null)}/>
      })()}
      {/* Lot 5c V2-prorata — modale de répartition (props pré-calculées dans
          openProrataModal ; render-guard XOR avec resaModal — MINEUR-1). */}
      {prorataModal && !resaModal && (
        <ProrataSplitModal
          lid={prorataModal.lid}
          code={prorataModal.code}
          logNom={prorataModal.logNom}
          voyageur={prorataModal.voyageur}
          naturalResa={prorataModal.naturalResa}
          naturalMontant={prorataModal.naturalMontant}
          montantTotal={prorataModal.montantTotal}
          monthsTouched={prorataModal.monthsTouched}
          monthLabels={prorataModal.monthLabels}
          frozenSet={prorataModal.frozenSet}
          existingSpec={prorataModal.existingSpec}
          posableFn={prorataModal.posableFn}
          onSet={prorataModal.onSet}
          onClear={prorataModal.onClear}
          onClose={()=>setProrataModal(null)}
        />
      )}
      {extraModal && <ExtraModal lid={extraModal.lid} logNom={extraModal.logNom} extra={extraModal.extra} onSave={e=>saveExtra(extraModal.lid,e)} onClose={()=>setExtraModal(null)}/>}
      {ajustModal && <ExtraModal lid={ajustModal.log.id} logNom={ajustModal.log.nom} extra={ajustModal.aj} title="un ajustement" hideDesc requireMontant placeholder="ex: -50 (négatif = déduction)" onSave={aj=>saveAjust(ajustModal.log,aj)} onClose={()=>setAjustModal(null)}/>}


      {/* ── Modal analyse business Claude ── */}
      {iaAnalyse && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:1001,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:DS.white,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:560,maxHeight:"85vh",display:"flex",flexDirection:"column",fontFamily:DS.fontBody}}>
            <div style={{padding:"16px 20px",borderBottom:"1px solid #f0f4f8",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0,background:"linear-gradient(135deg,#1a3f66,#215387)",borderRadius:"20px 20px 0 0"}}>
              <div>
                <div style={{fontFamily:DS.fontDisplay,fontWeight:700,color:"#fff",fontSize:15}}>🧠 Analyse Business — {monthLabel}</div>
                <div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginTop:2}}>Powered by Claude AI</div>
              </div>
              <button onClick={()=>setIaAnalyse(null)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:8,width:32,height:32,color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
            </div>
            <div style={{flex:1,overflowY:"auto",padding:"20px"}}>
              <div style={{fontSize:13,color:"#333",lineHeight:1.7,whiteSpace:"pre-wrap"}}>{iaAnalyse}</div>
            </div>
            <div style={{padding:"12px 20px",borderTop:"1px solid #f0f4f8",flexShrink:0}}>
              <button onClick={()=>{navigator.clipboard.writeText(iaAnalyse);alert("✅ Copié !")}}
                style={{width:"100%",padding:11,background:"#eef2f7",color:DS.navy,border:"none",borderRadius:10,fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:DS.fontBody}}>
                📋 Copier l'analyse
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
